import { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import CreateScannedDoc from '..';
import { MainContext } from '../../../../../../context/MainContext';
import {
  getScannedDocument,
  updateScannedDocument,
} from '../../../../../../services/api/scannedDocuments';
import {
  FORMSATTR,
  VALIDABLE_FALSE,
  VALIDABLE_TRUE,
  sortRegions,
} from './formItems';
import { useIntl } from 'react-intl';
import ErrorPage from '../../../Utils/ErrorPage';

const UpdateDeliveryScannedDoc = () => {
  const { setLoading, setError } = useContext(MainContext);
  const intl = useIntl();
  const { sdId } = useParams();
  const [initialData, setInitialData] = useState(null);
  const [componentError, createComponentError] = useState(null);
  const [loadedTemplate, setLoadedTemplate] = useState(null);
  const [validated, setValidated] = useState(null);
  const [camFileName, setCamFileName] = useState(null);
  const noTemplateMsg = intl.formatMessage({ id: 'noTemplate' });
  const noSupplierMsg = intl.formatMessage({ id: 'noSuppliers' });

  const updateSD = async (regions, formState, fileName) => {
    try {
      await updateScannedDocument(
        sdId,
        {
          delivery_note_data: {
            ...formState,
          },
          regions: !regions.some((r) => r.x === undefined) ? regions : [],
          fileName,
          camFileName: formState.camFileName,
        },
        'delivery',
      );

      return 'scannedDocUpdated';
    } catch (response) {
      setError(response);
    }
  };

  useEffect(() => {
    setLoading(true);
    const loadTemplate = async () => {
      try {
        const loadedSD = (await getScannedDocument(sdId)).data;
        setCamFileName(loadedSD.camFileName);
        setLoadedTemplate(loadedSD.template_data || {});
        const loadedDeliveryNote =
          loadedSD.delivery_note_data ||
          loadedSD.no_validated_delivery_note_data;
        setValidated(loadedSD.validated);
        const form = {
          templateName: loadedSD.template_data?.name || noTemplateMsg,
          supplier_id: loadedSD.supplier || noSupplierMsg,
          admixtures_extra: loadedDeliveryNote.admixtures_extra,
          detailed_location: loadedDeliveryNote.detailed_location,
          mash_control: loadedDeliveryNote.mash_control,
          start_discharging_time: loadedDeliveryNote.start_discharging_time,
          finish_discharging_time: loadedDeliveryNote.finish_discharging_time,
          arriving_time: loadedDeliveryNote.arriving_time,
          limit_time: loadedDeliveryNote.limit_time,
          elements: loadedDeliveryNote.elements,
        };
        if (form.mash_control) {
          form.specimens_number = loadedDeliveryNote.specimens_number;
          form.mash_control_extra = loadedDeliveryNote.mash_control_extra;
          form.slump = loadedDeliveryNote.slump;
        }
        setInitialData({
          form: form,
          regions: sortRegions(loadedSD.regions),
          regionsValue: loadedDeliveryNote,
        });
      } catch (error) {
        createComponentError(error);
      }
    };
    loadTemplate();
  }, [setLoading, setInitialData, sdId, noTemplateMsg, noSupplierMsg]);

  useEffect(() => {
    setLoading(false);
  }, [setLoading, createComponentError]);

  if (componentError) {
    return <ErrorPage errorMessages={componentError} />;
  }
  if (validated !== null)
    return (
      <CreateScannedDoc
        formsAttr={FORMSATTR}
        closeForm={updateSD}
        model="delivery"
        initialData={initialData}
        validable={validated ? VALIDABLE_TRUE : VALIDABLE_FALSE}
        loadedTemplate={loadedTemplate}
        initialCamFileName={camFileName}
      />
    );
  return null;
};

export default UpdateDeliveryScannedDoc;
